import type { EventName } from "@lit/react";
import { DatePickerLight as DatePickerLightElement, type DatePickerLightEventMap as _DatePickerLightEventMap, } from "@vaadin/date-picker/vaadin-date-picker-light.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { DatePickerLightElement, };
export type DatePickerLightEventMap = Readonly<{
    onValidated: EventName<_DatePickerLightEventMap["validated"]>;
    onChange: EventName<_DatePickerLightEventMap["change"]>;
    onOpenedChanged: EventName<_DatePickerLightEventMap["opened-changed"]>;
    onValueChanged: EventName<_DatePickerLightEventMap["value-changed"]>;
    onInvalidChanged: EventName<_DatePickerLightEventMap["invalid-changed"]>;
}>;
const events = { onValidated: "validated", onChange: "change", onOpenedChanged: "opened-changed", onValueChanged: "value-changed", onInvalidChanged: "invalid-changed" } as DatePickerLightEventMap;
export type DatePickerLightProps = WebComponentProps<DatePickerLightElement, DatePickerLightEventMap>;
export const DatePickerLight = createComponent({
    elementClass: DatePickerLightElement, events, react: React, tagName: "vaadin-date-picker-light"
});
